export const assessmentsMock = {
    result: "PASS"
}